import React from "react";
import Html from "./Html";

const ReCallVisitAlert = ({
    show,
    re_call_visit_id,
    handleClose
}) => {
    return (
        <Html show={show} re_call_visit_id={re_call_visit_id} handleClose={handleClose}/>
    );
};

export default ReCallVisitAlert;